import axios from 'axios';
import { MessageBox, Message } from 'element-ui';

function getName(){
    return localStorage.id
}

// showAlert 为true时，对code非0的进行弹窗提示错误信息，为false时，直接将返回值正常返回出去
function genRequest(config, showAlert = true) {
    // create an axios instance
    const service = axios.create({
        baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
        // withCredentials: true, // send cookies when cross-domain requests
        timeout: 500000, // request timeout
        withCredentials:true,
    });

    // request interceptor
    service.interceptors.request.use(
        (config) => {
            // do something before request is sent

            config.headers['userid'] = getName();
            return config;
        },
        (error) => {
            // do something with request error
            console.log(error); // for debug
            return Promise.reject(error);
        },
    );

    // response interceptor
    service.interceptors.response.use(
        /**
         * If you want to get http information such as headers or status
         * Please return  response => response
         */

        /**
         * Determine the request status by custom code
         * Here is just an example
         * You can also judge the status by HTTP Status Code
         */
        (response) => {
            const res = response.data;

            // 部分列表接口当total为0时，它的items为null，而非空数组，影响相关函数的使用，此处做一下转换
            try {
                if (res.data && res.data.total !== undefined && res.data.items !== undefined) {
                    if (typeof res.data.total === 'string' && /^[0-9]+$/.test(res.data.total)) {
                        res.data.total = parseInt(res.data.total, 10);
                    }
                    if (res.data.total === 0) {
                        res.data.items = [];
                    }
                }
            } catch (e) {
                console.log('error when process response:', e);
            }

            // if the custom code is not 20000, it is judged as an error.
            if (res.code !== 0 && res.state.code !== 0) {
                if (showAlert) {
                    Message({
                        message: res.state.msg || 'Error',
                        type: 'error',
                        duration: 5 * 1000,
                    });

                    // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
                    if (res.state.code === 50008 || res.state.code === 50012 || res.state.code === 50014) {
                        // to re-login
                        MessageBox.confirm(
                            'You have been logged out, you can cancel to stay on this page, or log in again',
                            'Confirm logout',
                            {
                                confirmButtonText: 'Re-Login',
                                cancelButtonText: 'Cancel',
                                type: 'warning',
                            },
                        ).then(() => {
                        });
                    }
                    return Promise.reject(new Error(res.state.msg || 'Error'));
                }
                return res;
            }
            return res;
        },
        (error) => {
            console.log(`err${error}`); // for debug
            Message({
                message: error.message,
                type: 'error',
                duration: 5 * 1000,
            });
            return Promise.reject({ code: -1 });
        },
    );

    // response interceptor
    // service.interceptors.response.use(
    //   /**
    //    * If you want to get http information such as headers or status
    //    * Please return  response => response
    //   */
    //
    //   /**
    //    * Determine the request status by custom code
    //    * Here is just an example
    //    * You can also judge the status by HTTP Status Code
    //    */
    //   response => {
    //     const res = response.data
    //
    //     // if the custom code is not 20000, it is judged as an error.
    //     if (res.code !== 20000) {
    //       Message({
    //         message: res.message || 'Error',
    //         type: 'error',
    //         duration: 5 * 1000
    //       })
    //
    //       // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    //       if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //         // to re-login
    //         MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
    //           confirmButtonText: 'Re-Login',
    //           cancelButtonText: 'Cancel',
    //           type: 'warning'
    //         }).then(() => {
    //           store.dispatch('user/resetToken').then(() => {
    //             location.reload()
    //           })
    //         })
    //       }
    //       return Promise.reject(new Error(res.message || 'Error'))
    //     } else {
    //       return res
    //     }
    //   },
    //   error => {
    //     console.log('err' + error) // for debug
    //     Message({
    //       message: error.message,
    //       type: 'error',
    //       duration: 5 * 1000
    //     })
    //     return Promise.reject(error)
    //   }
    // )
    return service(config);
}

export default genRequest;
